import { render } from "./TrainingModelComponent.vue?vue&type=template&id=71482428&scoped=true"
import script from "./TrainingModelComponent.vue?vue&type=script&lang=js"
export * from "./TrainingModelComponent.vue?vue&type=script&lang=js"

import "./TrainingModelComponent.vue?vue&type=style&index=0&id=71482428&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71482428"]])

export default __exports__